import { ChangeEvent, useState } from "react";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../../Context/Historico";
import { useUserInfor } from "../../../../Context/User";
import { AtualizarHistoricosController } from "../../../../Controllers/Cobranca/GestaoAtendimento/HistoricosControllers";
import { HistoricoInterface } from "../../../../Interfaces/Geral/Historicos/HistoricoInterface";
import { Spinner } from "../../../Loding/SpinnerPadrao";
import { FroalaEditor } from "../../Forms/Editor/FroalaEditor";
import { Switch } from "../../Forms/Switch";

interface ModalCadastrarPropsInterface {
    setShow: (show: boolean) => void;
    historico: HistoricoInterface;
}

function replaceImages(html: string, uploadedImages: string[]): string {
    let modifiedHTML = html;

    const imagesToReplace = modifiedHTML.match(/<img[^>]*src="blob[^"]*"[^>]*>/g) || [];
    imagesToReplace.forEach((imageTag) => {
        const uploadedImageUrl = uploadedImages.shift() || "";
        modifiedHTML = modifiedHTML.replace(
            /<img[^>]*src="blob[^"]*"[^>]*>/,
            imageTag.replace(/src="blob[^"]*"/, `src="${uploadedImageUrl}"`)
        );
    });

    const parser = new DOMParser();
    const doc = parser.parseFromString(modifiedHTML, "text/html");

    const imgNodes = doc.querySelectorAll('img[src^="https://docs.google.com/uc?id="]') as NodeListOf<HTMLImageElement>;
    imgNodes.forEach((img) => {
        if (img.src.includes("https://docs.google.com/uc?id=")) {
            img.src = img.src.replace("https://docs.google.com/uc?id=", "https://drive.google.com/thumbnail?id=");
            img.src += "&sz=w2000";
        }
    });

    return doc.documentElement.outerHTML;
}

export default function AtualizarHistorico(
    props: ModalCadastrarPropsInterface
) {
    const { Atendimento } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();
    const userId = useUserInfor().UserInfor.ID_USUARIO;
    const [uploading, setUploading] = useState(0);
    const [loading, setLoading] = useState(false);
    const [uploadedImages, setUploadedImages] = useState<string[]>([]);
    const [historicoHTML, setHistoricoHTML] = useState(
        () => replaceImages(props.historico.DS_HISTORICO, uploadedImages)
    );
    const [Selecionado, setSelecionado] = useState(false);

    const onSubmit = () => {
        if (userId && Atendimento && historicoHTML) {
            const modifiedHistoricoHTML = replaceImages(historicoHTML, uploadedImages);
            setLoading(true);
            AtualizarHistoricosController({
                ...props.historico,
                DS_HISTORICO: modifiedHistoricoHTML,
                FL_CLIENTE_VISUALIZA_HISTORICO: Selecionado,
            }).then(() => {
                props.setShow(false);
                setHistoricoHTML("");
                ReloadHistorico();
                setLoading(false);
            });
        }
    };
    function handleChange(e: ChangeEvent<HTMLInputElement>) {
        setSelecionado(e.target.checked);
    }

    return (
        <>
            <div className="text-center mb-lg-5">
                <h2 className="font-weight-bold">Atualização de Histórico</h2>
            </div>
            {uploading > 0 && (
                <div className="d-flex align-items-center justify-content-center g-2 p-2">
                    Fazendo upload de imagem{" "}
                    <Spinner size="sm" color="primary" />
                </div>
            )}
            {loading && (
                <div className="d-flex align-items-center justify-content-center g-2 p-2">
                    Salvando histórico{" "}
                    <Spinner size="sm" color="primary" />
                </div>
            )}
            <FroalaEditor
                onChange={setHistoricoHTML}
                onImageUploadStart={() => setUploading((prev) => prev + 1)}
                onImageUploadEnd={() => setUploading((prev) => prev - 1)}
                value={historicoHTML}
                setUploadedImages={setUploadedImages}
            />
            <Switch
                label="Cliente visualiza"
                type="checkbox"
                color="success"
                swicthSize="sm"
                checked={Selecionado}
                onChange={handleChange}
            />
            <div className="d-flex flex-wrap justify-content-center align-items-center lg-5 mt-1">
                <button
                    type="submit"
                    disabled={!historicoHTML.length || uploading > 0 || loading}
                    className="btn btn-capys font-weight-bold"
                    onClick={onSubmit}
                >
                    Atualizar
                </button>
            </div>
        </>
    );
}
